import { SlPicture } from "react-icons/sl";
import { AiOutlineBarcode } from "react-icons/ai";
import { FaUserPlus } from "react-icons/fa6";
import { CgTrack } from "react-icons/cg";
import { RiQuestionAnswerFill } from "react-icons/ri";
import { RiCoupon3Line } from "react-icons/ri";
import { MdSupportAgent } from "react-icons/md";
import { FaUserCog, FaWallet } from "react-icons/fa";
import { VscFeedback } from "react-icons/vsc";
import { IoSpeedometer } from "react-icons/io5";
import { FaTeamspeak } from "react-icons/fa";
import { PiNotepad } from "react-icons/pi";
import { MdAnalytics } from "react-icons/md";
import { MdCalendarMonth } from "react-icons/md";

export const navItems = [
  {
    id: 13,
    name: "Analytics",
    path: "/analytics",
    icon: <MdAnalytics />,
    permission: ["superAdmin", "admin"],
  },
  {
    id: 1,
    name: "Add New Member",
    path: "/add-member",
    icon: <FaUserPlus />,
    permission: ["superAdmin", "admin"],
  },
  {
    id: 2,
    name: "Orders Managment",
    path: "/",
    icon: <CgTrack />,
    permission: ["superAdmin", "admin"],
    children: [
      {
        id: 1,
        name: "View All Order",
        path: "/view-all-order",
        icon: <CgTrack />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 2,
        name: "Track Any Order",
        path: "/track-order",
        icon: <CgTrack />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 2,
        name: "Unsettled Orders",
        path: "/pending-settlement",
        icon: <CgTrack />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 9,
        name: "Cleaning Complaints",
        path: "/complaints",
        icon: <FaTeamspeak />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 12,
        name: "Initate Manual Order",
        path: "/place-manual-order",
        icon: <PiNotepad />,
        permission: ["superAdmin", "admin"],
      },
    ],
  },

  {
    id: 1,
    name: "Customer Quries",
    path: "/",
    icon: <IoSpeedometer />,
    permission: ["superAdmin", "admin"],
    children: [
      {
        id: 3,
        name: "Request A Callback",
        path: "/tickets",
        icon: <MdSupportAgent />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 4,
        name: "User Feedbacks",
        path: "/feedback",
        icon: <VscFeedback />,
        permission: ["superAdmin", "admin"],
      },
      {
        id: 5,
        name: "Reported Bug",
        path: "/reports",
        icon: <SlPicture />,
        permission: ["superAdmin", "admin"],
      },
    ],
  },
  {
    id: 6,
    name: "Add FAQs",
    path: "/question",
    icon: <RiQuestionAnswerFill />,
    permission: ["superAdmin", "admin"],
  },
  {
    id: 14,
    name: "Slot Managment",
    path: "/slot-managment",
    icon: <MdCalendarMonth />,
    permission: ["superAdmin", "admin"],
  },
  {
    id: 8,
    name: "Manage Member",
    path: "/manage-member",
    icon: <FaUserCog />,
    permission: ["superAdmin", "admin"],
  },
  {
    id: 10,
    name: "SuperAdmin Process",
    path: "/",
    icon: <AiOutlineBarcode />,
    permission: ["superAdmin"],
    children: [
      {
        id: 7,
        name: "Genrate Coupon Codes",
        path: "/add-coupon",
        icon: <RiCoupon3Line />,
        permission: ["superAdmin"],
      },
      {
        id: 8,
        name: "Collect Driver Cash",
        path: "/collect-cash",
        icon: <RiCoupon3Line />,
        permission: ["superAdmin"],
      },
      {
        id: 10,
        name: "Genrate Barcodes",
        path: "/add-barcodes",
        icon: <AiOutlineBarcode />,
        permission: ["superAdmin"],
      },
      {
        id: 11,
        name: "Add Wallet Balance",
        path: "/add-wallet-balance",
        icon: <FaWallet />,
        permission: ["superAdmin"],
      },
    ],
  },

  // {id:7, name:'Add Policy', path:"/add-policy", icon:<SlPicture />},
  // {id:7, name:'Add Instruction', path:"/add-instruction", icon:<SlPicture />}
];
